import React, { useEffect, useState } from 'react';
import useApiStable from '../../utils/useApiStable';
import '../../styles/TaskList.css';

function minutesToHours(minutes) {
  return (minutes / 60).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}

function BookingRow({ account, onBooked }) {
  const api = useApiStable();
  const [hours, setHours] = useState('');
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleBook = (sign) => {
    const parsedHours = parseFloat(hours);
    if (!parsedHours || parsedHours <= 0) {
      setError('Bitte eine positive Stundenzahl eingeben.');
      return;
    }
    const deltaMinutes = sign * Math.round(parsedHours * 60);
    if (deltaMinutes % 30 !== 0) {
      setError('Nur Schritte von 0,5 Stunden sind erlaubt.');
      return;
    }
    setError('');
    setSaving(true);
    api.post(`/workduty/accounts/${account.personId}/book`, { deltaMinutes, comment })
      .then(() => { setHours(''); setComment(''); onBooked(); })
      .catch(err => setError(err.message || 'Fehler beim Buchen'))
      .finally(() => setSaving(false));
  };

  return (
    <li className="tasklist-item" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
      <div className="tasklist-item-info">
        <strong>{account.personName}</strong> — Kontostand: {minutesToHours(account.balanceMinutes)} h
      </div>
      {error && <div className="taskform-error">{error}</div>}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8, alignItems: 'center' }}>
        <input type="number" step="0.5" min="0" placeholder="Stunden" value={hours}
               onChange={e => setHours(e.target.value)} style={{ width: 90 }} disabled={saving} />
        <input type="text" placeholder="Kommentar" value={comment}
               onChange={e => setComment(e.target.value)} style={{ flex: 1, minWidth: 140 }} disabled={saving} />
        <button className="tasklist-edit-btn" disabled={saving} onClick={() => handleBook(1)}>+ Gutschreiben</button>
        <button className="tasklist-edit-btn" style={{ background: '#888' }} disabled={saving} onClick={() => handleBook(-1)}>− Abbuchen</button>
      </div>
    </li>
  );
}

function WorkDutyAccountsPage() {
  const api = useApiStable();
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState('');
  const [yearlyResetHours, setYearlyResetHours] = useState('');
  const [settingsSaving, setSettingsSaving] = useState(false);
  const [settingsError, setSettingsError] = useState('');
  const [settingsSuccess, setSettingsSuccess] = useState('');

  const loadAccounts = () => {
    setError('');
    api.get('/workduty/accounts')
      .then(data => setAccounts(Array.isArray(data) ? data : []))
      .catch(err => setError(err.message || 'Fehler beim Laden der Konten'));
  };

  useEffect(() => {
    loadAccounts();
    api.get('/workduty/settings')
      .then(data => setYearlyResetHours(String(data.yearlyResetMinutes / 60)))
      .catch(err => setSettingsError(err.message || 'Fehler beim Laden der Einstellungen'));
  }, []); // eslint-disable-line

  const handleSaveSettings = (e) => {
    e.preventDefault();
    setSettingsError('');
    setSettingsSuccess('');
    const minutes = Math.round(parseFloat(yearlyResetHours) * 60);
    setSettingsSaving(true);
    api.put('/workduty/settings', { yearlyResetMinutes: minutes })
      .then(() => setSettingsSuccess('Gespeichert.'))
      .catch(err => setSettingsError(err.message || 'Fehler beim Speichern'))
      .finally(() => setSettingsSaving(false));
  };

  return (
    <div className="tasklist-container" style={{ maxWidth: 800 }}>
      <div className="tasklist-header">
        <h2>Arbeitsdienst-Konten</h2>
      </div>

      <form onSubmit={handleSaveSettings} className="taskform-card" style={{ marginTop: 0, marginBottom: 24 }}>
        <h3 style={{ marginBottom: 12 }}>Jahres-Startwert</h3>
        {settingsError && <div className="taskform-error">{settingsError}</div>}
        {settingsSuccess && <div style={{ color: '#2e7d32', fontSize: '0.85em', marginBottom: 8 }}>{settingsSuccess}</div>}
        <div className="taskform-inline-row">
          <div className="taskform-group">
            <label htmlFor="wd-yearly">Stunden pro Jahr (ab 01.01.)</label>
            <input id="wd-yearly" type="number" step="0.5" min="0" value={yearlyResetHours}
                   onChange={e => setYearlyResetHours(e.target.value)} disabled={settingsSaving} />
          </div>
          <div className="taskform-group" style={{ justifyContent: 'flex-end' }}>
            <button type="submit" className="taskform-save-btn" disabled={settingsSaving}>Speichern</button>
          </div>
        </div>
      </form>

      {error && <div style={{ color: '#c62828', fontSize: '0.85em', marginBottom: '8px' }}>{error}</div>}
      <ul className="tasklist-list">
        {accounts.map(account => (
          <BookingRow key={account.personId} account={account} onBooked={loadAccounts} />
        ))}
      </ul>
    </div>
  );
}

export default WorkDutyAccountsPage;
